<template lang="pug">
div
  template
    v-layout(row='', justify-center='')
      v-dialog(v-model='C.state.dialog.confirmArchiveInvention.active', max-width='290')
        v-card
          v-card-title.headline
            | Notice
          v-card-text
            | Do you wish to archive this invention?
          v-card-actions
            v-spacer
            v-btn(color='green darken-1', flat='flat', @click.native='C.state.dialog.confirmArchiveInvention.active = false')
              | Cancel
            v-btn(color='green darken-1', flat='flat', @click.native='C.trigger.confirmArchiveInvention()')
              | Confirm
  v-navigation-drawer.side-panel(v-model='P.state.selected.invention.active', width='680', right, temporary, fixed, hide-overlay, app)
    v-toolbar.transparent(tabs, flat, v-if='P.state.selected.invention.details')
      v-layout.pl-3.pr-2(row, nowrap, fill-height, align-end)
        v-tabs.side-panel__tabbar(slot='extension', slider-color='primary', v-model='P.state.sidepanel.tab')
          v-tab(href='#tab-1', :ripple="false")
            | Concept
          v-tab(href='#tab-2', :ripple="false")
            | Comments
          v-tab(href='#tab-3', :ripple="false")
            | Scratchpad
          v-tab(href='#tab-4', :ripple="false", v-on:click='C.trigger.refreshFormOrganizationOptions(P.form.selected.invention.organization_id, true)')
            | Details
        v-spacer
        v-btn(@click='C.form.trigger.letsinvent', :disabled='!P.form.selected.invention.title', flat, color='primary', v-if='(P.state.selected.invention.data.phase !== "phase-2" && P.state.selected.invention.data.phase !== "phase-3" && P.state.selected.invention.data.phase !== "phase-4" && P.state.selected.invention.data.phase !== "phase-5") && P.state.selected.invention.isEditable')
          | Let's Invent
        v-btn(@click='C.form.trigger.submit', :disabled='!P.form.selected.invention.title', color='primary', dark, v-if='P.state.selected.invention.isEditable')
          | {{ C.form.state.recentSaveActive ? 'Saved!' : 'Save' }}
        div
          v-btn(icon, flat, color='secondary', @click.stop='P.state.selected.invention.active = !P.state.selected.invention.active')
            v-icon close

    v-tabs-items.px-4(v-model='P.state.sidepanel.tab')
      v-tab-item.py-4.px-4(:key='1', :id='`tab-1`')
        .text-xs-right
        v-layout(column, nowrap)
          v-flex
            v-text-field.mb-3.input-group-large(v-model='P.form.selected.invention.title', label='Title of your concept', :disabled='(P.state.selected.invention.details && !P.state.selected.invention.isEditable)' :counter='100', solo)

        v-layout(row, nowrap)
          v-flex(v-if='!P.state.selected.invention.details' style="flex: 0 0 auto")
            v-btn(@click.stop='P.state.selected.invention.active = !P.state.selected.invention.active')
              | Cancel
            v-btn(@click='C.form.trigger.submit', :disabled='!P.form.selected.invention.title', color='primary')
              | Continue

        v-layout.mt-4(row, wrap, v-if='P.state.selected.invention.details')
          v-flex.mb-2(xs12)
            label Summary of concept
          v-flex(xs12)
            froala(v-model='P.form.selected.invention.description', ref='invention_description', :config='C.form.config.froala.invention.description', v-if='P.state.selected.invention.isEditable')
            p(v-html='P.form.selected.invention.description', v-if='!P.state.selected.invention.isEditable')

      v-tab-item.py-4.px-4(:key='2', :id='`tab-2`')
        v-layout(row, wrap)
          v-flex(xs12, v-for='comment in P.form.selected.comments.$list', :key='comment.id')
            v-card.card--borderless.pb-3(flat)
              v-layout(row, nowrap, justify-space-between)
                v-flex(xs1)
                  avatar(:username='comment.user_name ? comment.user_name : "?"')
                v-flex.pl-4
                  v-layout.mb-2(row, nowrap, justify-space-between, align-center)
                    .title
                      | {{ comment.user_name }}
                    .grey--text
                      | {{ comment.created_time | moment("h:mm A, MMM D, YYYY") }}
                  .subheading
                    | {{ comment.content }}
            v-divider

          v-flex(xs12)
            v-card.card--borderless.py-0(flat)
              v-layout(row, nowrap, justify-space-between)
                v-flex(xs1)
                  avatar.mt-4(:username='CR.authorization.data.fullname ? CR.authorization.data.fullname : "?"')
                v-flex.pl-4
                  v-text-field(v-model='P.form.selected.comments.content', textarea, label='Comment', :counter='500', auto-grow, rows='2')

              v-layout(row, nowrap, justify-end)
                  v-btn.ma-0(color='secondary', @click='C.form.trigger.addComment')
                    | Send

      v-tab-item.py-4.px-4(:key='3', :id='`tab-3`')
        .text-xs-right
        v-layout(row, wrap)
          v-flex(xs12)
            froala(v-model='P.form.selected.scratchpad', :config='C.form.config.froala.invention.description', v-if='P.state.selected.invention.isEditable')
            p(v-html='P.form.selected.scratchpad', v-if='!P.state.selected.invention.isEditable')

      v-tab-item.py-4.px-4(:key='4', :id='`tab-4`')

        v-alert.mt-1.mb-4(type='error', :value='true', v-if='P.form.error.active && ((P.form.error.type === "letsinvent-missingfields-organization" && !P.form.selected.invention.organization_id) || (P.form.error.type === "letsinvent-missingfields-opportunity" && !P.form.selected.invention.invention_opportunity_id) || (P.form.error.type === "N/A"))')
          span(v-if='P.form.error.type === "letsinvent-missingfields-organization" && !P.form.selected.invention.organization_id')
            | Please select an organization.
          span(v-if='P.form.error.type === "letsinvent-missingfields-opportunity" && !P.form.selected.invention.invention_opportunity_id')
            | Please select an opportunity.
          span(v-if='P.form.error.type === "N/A"')
            | Sorry, something has went wrong!

        v-layout.edit-inline(row, v-if='C.form.list.organizations.length > 1')
          v-flex
            v-icon(color='secondary') business
          v-flex
            v-select.input--box(v-model='P.form.selected.invention.organization_id', v-on:change='C.trigger.refreshFormOrganizationOptions($event)' single-line, label='Organization', :disabled='P.state.selected.invention.details && (!!P.state.selected.invention.data.organization || !P.state.selected.invention.isEditable)', v-bind:items='C.form.list.organizations', item-text='name', item-value='id', required)
        v-layout.edit-inline(row, v-if='P.form.selected.invention.organization_id || C.form.list.organizations.length === 1')
          v-flex
            v-icon(color='secondary') add_to_photos
          v-flex
            v-select.input--box(v-model='P.form.selected.invention.invention_opportunity_id', single-line, label='Opportunity', v-bind:items='C.form.list.opportunities', item-text='title', item-value='id', :disabled='!P.state.selected.invention.isEditable')

        v-layout(row, wrap, v-if='P.state.selected.invention.isEditable && CR.show.unreleased')
          v-flex(xs12)
            v-text-field(v-model='P.form.selected.invention.$search.title', label='Add a Search', multi-line, auto-grow, rows="1", prepend-icon="search", v-on:focus='C.form.state.active.$search = true')

        transition(name='expand', v-if='P.state.selected.invention.isEditable && CR.show.unreleased')
          .mb-3(v-if="C.form.state.active.$search")
            v-flex(xs12)
              v-text-field(v-model='P.form.selected.invention.$search.url', label='Paste URL', multi-line, auto-grow, rows="1", prepend-icon="insert_link")
            v-flex(xs12)
              v-text-field(v-model='P.form.selected.invention.$search.note', label='Search Note', multi-line, auto-grow, rows="1", prepend-icon="note")
            v-flex(style="padding-left: 33px;")
              v-btn(color="primary", v-on:click='C.form.trigger.addSearchItem()') Save Search
              v-btn(v-on:click='C.form.state.active.$search = false') Cancel
        v-layout.mb-3(row, nowrap, align-start, v-for='(searchItem, searchItemIndex) in P.form.selected.invention.search', :key='searchItemIndex', v-if='CR.show.unreleased')
            v-icon youtube_searched_for
            v-flex.pl-3
              p.mb-0(v-if='!searchItem.url')
                | {{ searchItem.title }}
              a(:href='searchItem.url', target='_blank', v-if='searchItem.url')
                | {{ searchItem.title }}
              p.mb-0.grey--text {{ searchItem.note }}
            .search-list__close(v-if='P.state.selected.invention.isEditable')
              v-btn(@click='C.form.trigger.removeSearchItem(searchItem, searchItemIndex)', flat, icon, color='secondary', v-if='!searchItem.remove')
                v-icon close
              v-btn(@click='C.form.trigger.removeSearchItem(searchItem, searchItemIndex)', fab, small, icon, color='secondary', dark, v-if='searchItem.remove')
                v-icon close

        v-layout.edit-inline(row, v-if='(P.form.selected.invention.organization_id || C.form.list.organizations.length === 1) && P.state.selected.invention.isEditable')
          v-flex
            v-icon(color='secondary') comment
          v-flex
            v-select.input--box(v-model='P.form.selected.invention.bulk_read_access', hint="Bulk Read Access", persistent-hint, v-bind:items='C.form.list.bulkDefaultAccessOptions', item-text='label', item-value='value')
        v-layout.edit-inline(row, align-start, justify-space-between, v-if='(P.form.selected.invention.organization_id || C.form.list.organizations.length === 1) && P.state.selected.invention.isEditable')
          v-flex
            v-icon(color='secondary') people
          v-flex.mr-3(style='flex: 0 0 220px')
            v-select.input--box(v-model='P.form.selected.$collaborator.$item', single-line, label='User', autocomplete, v-bind:items='C.form.list.inventors | F_availableCollaborators(P.form.selected.co_inventors)', item-text='fullname', hide-details)
          v-flex
            v-select.input--box(v-model='P.form.selected.$collaborator.access', single-line, label='Access', v-bind:items='C.form.list.collaboratorAccessOptions.items | F_availableAccess(P.state.selected.invention.data.phase)', item-text='label', item-value='value', hide-details)
          v-spacer
          v-flex(style='flex: 0 0 auto')
            v-btn.ma-0(color="secondary", v-on:click='C.form.trigger.addCollaboratorItem()')
              | Add Collaborator

        v-layout.edit-inline
          v-flex
          v-flex
            v-list(dense, v-for='(collaborator, collaboratorIndex) in P.form.selected.co_inventors', :key='collaborator.user_id')
              v-list-tile
                v-list-tile-content
                  v-list-tile-title
                    h3(color='primary') {{ collaborator.$name }}
                  v-list-tile-sub-title
                    | {{ collaborator.access && C.form.list.collaboratorAccessOptions.dictionary[collaborator.access.toString()] }}
                v-list-tile-action(v-if='P.state.selected.invention.isEditable')
                  v-btn(@click='C.form.trigger.removeCollaboratorItem(collaborator, collaboratorIndex)', flat, icon, color='secondary', v-if='!collaborator.remove')
                    v-icon close
                  v-btn(@click='C.form.trigger.removeCollaboratorItem(collaborator, collaboratorIndex)', fab, small, icon, color='secondary', dark, v-if='collaborator.remove')
                    v-icon close

        v-layout.edit-inline(v-if='P.state.selected.invention.data.role === "Inventor"')
          v-flex
            v-icon(color='secondary') close
          v-flex
            a(@click='C.form.trigger.archiveInvention()')
              | Archive this concept

</template>
<script>
  import Vue from 'vue'

  import globalSettings from '../../assets/global-settings.js'
  import tools from '../../assets/tools.js'

  import axios from '../../../node_modules/axios/dist/axios.js'
  import _ from '../../../node_modules/underscore/underscore-min.js'
  import Avatar from 'vue-avatar'

  export default {
    components: {
      Avatar
    },
    props: ['P'],
    data () {
      return {
        CR: {
          authorization: globalSettings.authorization,
          show: globalSettings.show
        },
        C: {
          state: {
            dialog: {
              confirmArchiveInvention: {
                active: false
              }
            }
          },
          timer: {
            autoSave: null,
            saveIndicator: null
          },
          form: {
            config: {
              froala: {
                invention: {
                  description: tools.setupFroalaConfig({
                    events: {
                      'contentChanged': () => {
                        var component = this

                        if (component.P.state.selected.invention.details) {
                          clearTimeout(component.C.timer.autoSave)

                          component.C.timer.autoSave = setTimeout(function () {
                            component.C.form.trigger.submit(function () {
                              component.C.form.state.recentSaveActive = true

                              clearTimeout(component.C.timer.saveIndicator)

                              component.C.timer.saveIndicator = setTimeout(function () {
                                component.C.form.state.recentSaveActive = false
                              }, 5000)
                            }, true)
                          }, 2000)
                        }
                      }
                    }
                  })
                }
              }
            },
            state: {
              active: {
                $search: false
              },
              recentSaveActive: false
            },
            list: {
              inventionActions: [{
                label: 'Brainstorm',
                value: 'Brainstorm'
              }, {
                label: 'Research',
                value: 'Research'
              }, {
                label: 'Archive',
                value: 'Archive'
              }, {
                label: 'Other',
                value: 'Other'
              }],
              collaboratorAccessOptions: {
                items: [{
                  label: 'Co-inventor',
                  value: 1
                }, {
                  label: 'Mentor/Expert',
                  value: 2
                }, {
                  label: 'Commenter',
                  value: 3
                }],
                dictionary: {
                  '1': 'Co-inventor',
                  '2': 'Mentor/Expert',
                  '3': 'Commenter'
                }
              },
              bulkDefaultAccessOptions: [{
                label: 'Anyone in my organization can comment',
                value: 'anyone-organization'
              }, {
                label: 'Only collaborators in my organization can comment',
                value: 'only-inventors'
              }],
              organizations: [],
              opportunities: [],
              inventors: []
            },
            trigger: {
              addSearchItem: (searchItem) => {
                var component = this

                component.P.form.selected.invention.search.push({
                  title: component.P.form.selected.invention.$search.title,
                  url: component.P.form.selected.invention.$search.url,
                  note: component.P.form.selected.invention.$search.note,
                  tag: component.P.form.selected.invention.$search.tag
                })

                component.P.form.selected.invention.$search.title = ''
                component.P.form.selected.invention.$search.url = ''
                component.P.form.selected.invention.$search.note = ''
                component.P.form.selected.invention.$search.tag = ''

                component.C.form.state.active.$search = false
              },
              removeSearchItem: (searchItem, searchItemIndex) => {
                var component = this

                if (!searchItem.id) {
                  component.P.form.selected.invention.search.splice(searchItemIndex, 1)
                } else {
                  Vue.set(searchItem, 'remove', !searchItem.remove)
                }
              },
              addCollaboratorItem: () => {
                var component = this

                if (component.P.form.selected.$collaborator.$item && component.P.form.selected.$collaborator.access) {
                  component.P.form.selected.co_inventors.push({
                    $isNew: true,
                    $name: component.P.form.selected.$collaborator.$item.fullname,
                    user_id: component.P.form.selected.$collaborator.$item.id,
                    access: component.P.form.selected.$collaborator.access,
                    remove: false
                  })

                  component.P.form.selected.$collaborator.$item = null
                  component.P.form.selected.$collaborator.access = null
                }
              },
              removeCollaboratorItem: (collaboratorItem, collaboratorIndex) => {
                var component = this

                if (collaboratorItem.$isNew) {
                  component.P.form.selected.co_inventors.splice(collaboratorIndex, 1)
                } else {
                  Vue.set(collaboratorItem, 'remove', !collaboratorItem.remove)
                }
              },
              fileUpload: ($event) => {
                var component = this

                var $files = $event.target.files || $event.dataTransfer.files

                if (!$files.length) {
                  return
                }

                var targetFile = $files[0]

                component.P.form.selected.upload = targetFile
              },
              downloadFile: () => {
                var component = this

                console.log('Running C.form.trigger.downloadFile()')

                axios.get(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/inventions/download_uploaded_file`, {
                  params: {
                    invention_id: component.P.form.selected.invention_id
                  },
                  responseType: 'blob'
                })
                     .then(response => {
                       const url = window.URL.createObjectURL(new Blob([response.data]))
                       const link = document.createElement('a')

                       link.href = url
                       link.setAttribute('download', component.P.form.selected.invention.uploaded_filename)
                       document.body.appendChild(link)
                       link.click()
                     })
                     .catch(errorResponse => {
                       tools.alert({
                         type: 'error',
                         errorResponse: errorResponse
                       })
                     })
              },
              addComment: () => {
                var component = this

                var apiCallPromise = null

                var submitBlob = new FormData()
                submitBlob.append('invention_id', component.P.form.selected.invention_id)
                submitBlob.append('content', component.P.form.selected.comments.content)

                apiCallPromise = axios.post(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/inventions/add_comment`, submitBlob)

                if (apiCallPromise) {
                  apiCallPromise
                    .then(function (response) {
                      console.info('Add Comment Results: ', response.data)

                      component.P.form.selected.comments.$list = (response.data && response.data.data && response.data.data.invention && response.data.data.invention.comments) || []

                      component.P.form.selected.comments.content = ''
                    })
                    .catch(function (errorResponse) {
                      tools.alert({
                        type: 'error',
                        errorResponse: errorResponse
                      })
                    })
                }
              },
              archiveInvention: () => {
                var component = this

                component.C.state.dialog.confirmArchiveInvention.active = true
              },
              letsinvent: () => {
                var component = this

                if ((component.P.form.selected.invention.organization_id || component.C.form.list.organizations.length <= 1) && component.P.form.selected.invention.invention_opportunity_id) {
                  component.C.form.trigger.submit(function () {
                    axios.put(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/inventions/update_phase`, {
                      invention_id: component.P.form.selected.invention_id,
                      phase: 'phase-2'
                    })
                      .then(function (response) {
                        console.info('Update Phase Results: ', response.data)

                        component.$router.push({
                          name: 'InventionSolution',
                          params: {
                            id: component.P.form.selected.invention_id
                          }
                        })
                      })
                      .catch(function (errorResponse) {
                        tools.alert({
                          type: 'error',
                          errorResponse: errorResponse
                        })
                      })
                  })
                } else {
                  component.P.state.sidepanel.tab = 'tab-4'

                  if (!(component.P.form.selected.invention.organization_id || component.C.form.list.organizations.length <= 1)) {
                    component.P.form.error.active = true
                    component.P.form.error.type = 'letsinvent-missingfields-organization'
                  } else if (!component.P.form.selected.invention.invention_opportunity_id) {
                    component.P.form.error.active = true
                    component.P.form.error.type = 'letsinvent-missingfields-opportunity'
                  } else {
                    component.P.form.error.active = true
                    component.P.form.error.type = 'N/A'

                    console.error('component.P.form.selected.invention', component.P.form.selected.invention)
                  }
                }
              },
              submit: (callback, skipClose) => {
                var component = this

                var apiCallPromise = null

                var submitBlob = new FormData()
                submitBlob.append('invention[title]', component.P.form.selected.invention.title)
                submitBlob.append('invention[description]', component.P.form.selected.invention.description)
                submitBlob.append('invention[action]', component.P.form.selected.invention.action)
                submitBlob.append('invention[action_note]', component.P.form.selected.invention.action_note)

                submitBlob.append('scratchpad', component.P.form.selected.scratchpad)

                if (component.P.form.selected.invention.invention_opportunity_id === '$other') {
                  submitBlob.append('invention[invention_opportunity_id]', 'other')
                } else if (component.P.form.selected.invention.invention_opportunity_id) {
                  submitBlob.append('invention[invention_opportunity_id]', component.P.form.selected.invention.invention_opportunity_id)
                }

                if (!skipClose) {
                  for (var i = 0; i < component.P.form.selected.co_inventors.length; i++) {
                    submitBlob.append('co_inventors[][user_id]', component.P.form.selected.co_inventors[i].user_id)
                    submitBlob.append('co_inventors[][access]', component.P.form.selected.co_inventors[i].access)
                    submitBlob.append('co_inventors[][remove]', component.P.form.selected.co_inventors[i].remove || false)
                  }

                  if (component.P.form.selected.$collaborator.$item && component.P.form.selected.$collaborator.access) {
                    submitBlob.append('co_inventors[][user_id]', component.P.form.selected.$collaborator.$item.id)
                    submitBlob.append('co_inventors[][access]', component.P.form.selected.$collaborator.access)
                    submitBlob.append('co_inventors[][remove]', false)
                  }

                  if (component.C.form.list.organizations.length === 1) {
                    submitBlob.append('invention[organization_id]', component.C.form.list.organizations[0].id)
                  } else if (component.P.form.selected.invention.organization_id) {
                    submitBlob.append('invention[organization_id]', component.P.form.selected.invention.organization_id)
                  }

                  for (i = 0; i < component.P.form.selected.invention.search.length; i++) {
                    var targetSearchItem = component.P.form.selected.invention.search[i]

                    submitBlob.append('searches[][id]', (targetSearchItem.id || null))
                    submitBlob.append('searches[][title]', targetSearchItem.title)
                    submitBlob.append('searches[][url]', targetSearchItem.url)
                    submitBlob.append('searches[][note]', targetSearchItem.note)
                    submitBlob.append('searches[][tag]', targetSearchItem.tag)
                    submitBlob.append('searches[][remove]', (targetSearchItem.remove || false))
                  }

                  if (component.P.form.selected.invention.$search.title) {
                    submitBlob.append('searches[][id]', null)
                    submitBlob.append('searches[][title]', component.P.form.selected.invention.$search.title)
                    submitBlob.append('searches[][url]', component.P.form.selected.invention.$search.url)
                    submitBlob.append('searches[][note]', component.P.form.selected.invention.$search.note)
                    submitBlob.append('searches[][tag]', component.P.form.selected.invention.$search.tag)
                    submitBlob.append('searches[][remove]', false)
                  }

                  if (component.P.form.selected.upload) {
                    submitBlob.append('upload', component.P.form.selected.upload)
                  }
                } else {
                  if (!_.isNull(component.P.state.selected.invention.data.organization && component.P.state.selected.invention.data.organization.id)) {
                    submitBlob.append('invention[organization_id]', component.P.state.selected.invention.data.organization && component.P.state.selected.invention.data.organization.id)
                  }
                }

                if (component.P.form.selected.invention.bulk_read_access) {
                  submitBlob.append('invention[bulk_read_access]', component.P.form.selected.invention.bulk_read_access)
                }

                if (!component.P.state.selected.invention.details) {
                  apiCallPromise = axios.post(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/inventions/create`, submitBlob)
                } else {
                  submitBlob.append('invention_id', component.P.form.selected.invention_id)

                  apiCallPromise = axios.put(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/inventions/update`, submitBlob)
                }

                if (apiCallPromise) {
                  apiCallPromise
                    .then(function (response) {
                      console.info('Manage Invention Results: ', response.data)

                      if (component.P.state.selected.invention.details) {
                        if (!skipClose) {
                          component.P.state.selected.invention.active = false
                        }
                      } else {
                        component.P.trigger.selectInvention(response.data.data.invention)
                      }

                      if (_.isFunction(callback)) {
                        callback()
                      } else {
                        component.P.trigger.refreshBaseData()

                        if (component.P.state.selected.invention.details) {
                          tools.alert({
                            type: 'success',
                            message: `${component.P.form.selected.invention.title} has been successfully saved.`
                          })
                        }
                      }

                      if (!skipClose) {
                        component.P.form.selected.invention.$search.title = ''
                        component.P.form.selected.invention.$search.url = ''
                        component.P.form.selected.invention.$search.note = ''
                        component.P.form.selected.invention.$search.tag = ''
                        component.C.form.state.active.$search = false
                      }
                    })
                    .catch(function (errorResponse) {
                      tools.alert({
                        type: 'error',
                        errorResponse: errorResponse
                      })
                    })
                }
              }
            }
          },
          trigger: {
            confirmArchiveInvention: () => {
              var component = this

              var submitItem = {
                invention_id: component.P.form.selected.invention_id,
                archived: true
              }

              axios.put(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/inventions/update_archived`, submitItem)
                .then(function (response) {
                  console.info('Archive Invention Results: ', response.data)

                  component.P.state.selected.invention.active = false

                  component.P.trigger.refreshBaseData()

                  tools.alert({
                    type: 'success',
                    message: `${component.P.form.selected.invention.title} has been successfully archived.`
                  })

                  component.P.form.selected.invention.$search.title = ''
                  component.P.form.selected.invention.$search.url = ''
                  component.P.form.selected.invention.$search.note = ''
                  component.P.form.selected.invention.$search.tag = ''
                  component.C.form.state.active.$search = false

                  component.C.state.dialog.confirmArchiveInvention.active = false
                })
                .catch(function (errorResponse) {
                  tools.alert({
                    type: 'error',
                    errorResponse: errorResponse
                  })
                })
            },
            refreshFormListData: (options) => {
              var component = this

              tools.getOrganizationsList({
                success: function (organizationList) {
                  component.P.filters.list.organizations = organizationList
                  component.C.form.list.organizations = organizationList

                  if (component.C.form.list.organizations.length === 1) {
                    component.C.trigger.refreshFormOrganizationOptions(component.C.form.list.organizations[0].id, true)
                  }
                }
              })
            },
            refreshFormOrganizationOptions: (targetOrganizationID, isLoad) => {
              var component = this

              if (targetOrganizationID) {
                axios.get(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/organizations/opportunities_and_inventors`, {
                  params: {
                    organization_id: targetOrganizationID
                  }
                })
                     .then(response => {
                       var opportunitiesList = (response && response.data && response.data.data && response.data.data.invention_opportunities) || []
                       var peopleList = (response && response.data && response.data.data && response.data.data.inventors) || []

                       opportunitiesList.push({
                         id: '$other',
                         title: 'Other'
                       })

                       component.C.form.list.opportunities = opportunitiesList
                       component.C.form.list.inventors = peopleList

                       component.P.form.selected.$collaborator.$item = null
                       component.P.form.selected.$collaborator.access = null

                       if (!(component.P.state.selected.invention.details && isLoad)) {
                         component.P.form.selected.invention.invention_opportunity_id = null
                         component.P.form.selected.co_inventors = []
                       }
                     })
                     .catch(errorResponse => {
                       tools.alert({
                         type: 'error',
                         errorResponse: errorResponse
                       })
                     })
              }
            }
          }
        }
      }
    },
    created () {
      var component = this

      component.C.trigger.refreshFormListData()
    },
    beforeDestroy () {
      var component = this

      clearTimeout(component.C.timer.autoSave)
    },
    filters: {
      F_availableCollaborators: (currentList, selectedList) => {
        var filteredList = []

        for (var i = 0; i < currentList.length; i++) {
          var currentCollaborator = currentList[i]

          var correspondingSelectedCollaborator = _.find(selectedList, function (selectedCollaborator) {
            return selectedCollaborator.user_id === currentCollaborator.id
          })

          if (!correspondingSelectedCollaborator) {
            filteredList.push(currentCollaborator)
          }
        }

        return filteredList
      },
      F_availableAccess: (currentList, targetPhase) => {
        var filteredList = []

        for (var i = 0; i < currentList.length; i++) {
          var currentCollaborator = currentList[i]

          if (currentCollaborator.value === 2) {
            if (targetPhase === 'phase-3' || targetPhase === 'phase-4' || targetPhase === 'phase-5') {
              filteredList.push(currentCollaborator)
            }
          } else {
            filteredList.push(currentCollaborator)
          }
        }

        return filteredList
      }
    }
  }
</script>

<style scoped lang="scss">
.side-panel {
  .side-panel__tabbar {
    padding-left: 32px;
  }
}
.tab--next {
  margin-left: auto;
}
.tabs__content {
  transition: none !important;
}
.inventions__tabs {
  border-bottom: 1px solid #ccc;
}
.search-idea__list {
  .list__tile {
    padding: 0;
  }
}
.theme--dark.btn.btn--disabled {
  color: rgba(0,0,0,0.26) !important;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/Inventions/SidePanel.vue